import React from 'react';
import { Block } from 'slate';
import Row from 'base/components/Row';
import {
  ColumnsThreeEqualIcon,
  ColumnsTwoEqualIcon,
  ColumnsTwoSidebarLeftIcon,
  DeleteIcon,
} from 'base/components/Icon';
import FloatingToolbar from '../../components/FloatingToolbar';
import ToolbarButton from '../../components/ToolbarButton';

import Wrapper from '../../components/Wrapper';

const colBlockJson = {
  object: 'block',
  type: 'col',
  nodes: [
    {
      object: 'block',
      type: 'paragraph',
      nodes: [
        {
          object: 'text',
          text: '',
        },
      ],
    },
  ],
};


class Columns extends React.Component {
  layouts = {
    'two-equal': {
      label: 'Two columns, equal width',
      columnCount: 2,
      widths: ['50%', 'auto'],
      icon: ColumnsTwoEqualIcon,
    },
    'two-sidebar-left': {
      label: 'Two columns, sidebar left',
      columnCount: 2,
      widths: ['33.33%', 'auto'],
      icon: ColumnsTwoSidebarLeftIcon,
    },
    'three-equal': {
      label: 'Three columns, equal width',
      columnCount: 3,
      widths: ['33.33%', '33.33%', 'auto'],
      icon: ColumnsThreeEqualIcon,
    },
  };

  layoutOptions = Object.entries(this.layouts).map(([key, layout]) => {
    const Icon = layout.icon;
    return (
      <ToolbarButton
        key={key}
        icon={<Icon />}
        onClick={() => this.changeLayout(key)}
        label={layout.label}
      />
    );
  });

  changeLayout = (layoutKey) => {
    const { node } = this.props;
    const newLayout = this.layouts[layoutKey];
    if (node.nodes.size < newLayout.columnCount) {
      this.appendColumn(newLayout.columnCount);
    } else if (node.nodes.size > newLayout.columnCount) {
      this.redistributeContentToRemainingColumns(newLayout.columnCount);
      this.removeColumnsAfterIndex(newLayout.columnCount - 1);
    }

    this.updateWidths(newLayout.widths);
  };

  appendColumn = () => {
    const { node, editor } = this.props;
    const newCol = Block.create(colBlockJson);
    editor.insertNodeByKey(node.key, node.nodes.size, newCol);
  };

  redistributeContentToRemainingColumns = (newColumnCount) => {
    const { node, editor } = this.props;
    const lastCol = node.nodes.get(newColumnCount - 1);
    node.nodes.forEach((col, i) => {
      if (i >= newColumnCount) {
        col.nodes.forEach((colContent) => {
          editor.moveNodeByKey(colContent.key, lastCol.key, lastCol.nodes.size);
        });
      }
    });
  };

  removeColumnsAfterIndex = (index) => {
    const { node, editor } = this.props;
    node.nodes.forEach((col, i) => {
      if (i > index) {
        editor.removeNodeByKey(col.key);
      }
    });
  };

  updateWidths = (newWidths) => {
    const { node, editor } = this.props;
    node.nodes.forEach((col, i) => {
      const width = newWidths[i] === 'auto' ? undefined : newWidths[i];
      editor.setNodeByKey(col.key, { data: { width } });
    });
  };

  handleRemove = (e) => {
    e.stopPropagation();
    const { editor, node } = this.props;
    editor.removeNodeByKey(node.key);
  };


  render() {
    const {
      isFocused, editor, node, readOnly, ...props
    } = this.props;
    const hasFocus = isFocused && !readOnly && !['image', 'video'].includes(editor.value.startBlock.type);
    return (
      <Wrapper isFocused={hasFocus} readOnly={readOnly}>
        <Row style={{ marginBottom: '1rem' }} {...props} />
        {hasFocus && (
          <FloatingToolbar contentEditable={false}>
            {this.layoutOptions}
            <ToolbarButton icon={<DeleteIcon />} onClick={this.handleRemove} label="Remove columns" />
          </FloatingToolbar>
        )}
      </Wrapper>
    );
  }
}


export default Columns;
